module.exports = __webpack_public_path__ + "img/Familienbild.65ab42c5.svg";